import {
  ClockIcon,
  OnlineBankIcon,
  PhoneInCircleIcon,
  Spacer,
  Title,
} from 'internalLibrary';
import { FC } from 'react';
import { R } from 'config/app';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import layout from '../../../../scss/layout.module.scss';
import OptionCardButton from 'ui/components/OptionCardButton';
import style from './IdentificationMethod.module.scss';
import useIdentificationManualMutation from 'ui/hooks/useIdentificationManualMutation';

const IdentificationMethodContent: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutateAsync: putIdentificationManual, isLoading } =
    useIdentificationManualMutation();

  const onlineBankClicked = () => {
    navigate(R.FirstLoanTink);
  };

  const manualIdentifictionClicked = async () => {
    await putIdentificationManual({});
    navigate(R.FirstLoanPendingManual);
  };

  return (
    <div>
      <Title text={t('identificationMethod_title')} className={style.title} />
      <Spacer className={layout['width-lg']}>
        <OptionCardButton
          onClick={onlineBankClicked}
          className={style.card}
          leftIcon={<OnlineBankIcon />}
          title={t('bank_title')}
          subtitle={
            <CardContent
              description={t('bank_description')}
              duration={t('bank_duration')}
            />
          }
          etiquette={t('bank_recommended')}
          intent="info"
        />

        <OptionCardButton
          onClick={isLoading ? undefined : manualIdentifictionClicked}
          leftIcon={<PhoneInCircleIcon />}
          title={t('manual_title')}
          subtitle={
            <CardContent
              description={t('manual_description')}
              duration={t('manual_duration')}
            />
          }
        />
      </Spacer>
    </div>
  );
};

export default IdentificationMethodContent;

const CardContent: FC<{ description: string; duration: string }> = ({
  description,
  duration,
}) => {
  return (
    <div className={style['card-content']}>
      <span className={style['card-description']}>{description}</span>
      <span className={style['card-duration']}>
        <ClockIcon /> {duration}
      </span>
    </div>
  );
};
